module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="fmcy-category-menu-item-text">'+
((__t=(name))==null?'':__t)+
'</div>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/subfilters/search-filters/search-filter-tabs/search-filters-item/search-filters-item.html
 ** module id = 335
 ** module chunks = 1 7 43 72 108 116
 **/